export default __webpack_public_path__ + "assets/images/started.29a6d4.png";